import { apiPost, apiRequestGet } from './apiClient';
import type { BulkImportRow, ImportMode } from '../components/bulkImport/types';

const root = (propertyId: string) => `/properties/${encodeURIComponent(propertyId)}/bulk-import`;
export async function createImportUpload(propertyId: string, file: File) {
  const upload = await apiPost(`${root(propertyId)}/uploads`, { file_name: file.name, mime_type: file.type, byte_size: file.size });
  const response = await fetch(upload.upload_url, {
    method: 'PUT',
    headers: {
      'Content-Type': file.type,
      'x-amz-server-side-encryption': 'AES256',
    },
    body: file,
  });
  if (!response.ok) throw new Error(`Upload failed (${response.status})`);
  return upload;
}
export const parseImport = (propertyId: string, data: Record<string, unknown>) => apiPost(`${root(propertyId)}/parse`, data);
export const normalizeImport = (propertyId: string, rows: BulkImportRow[], mode: ImportMode, vacancy_markers: string[], source?: Record<string, unknown>) => apiPost(`${root(propertyId)}/normalize`, { rows, mode, vacancy_markers, ...(source || {}) });
export const saveMappingProfile = (propertyId: string, data: Record<string, unknown>) => apiPost(`${root(propertyId)}/mapping-profiles`, data);
export const listMappingProfiles = (propertyId: string) => apiRequestGet(`${root(propertyId)}/mapping-profiles`);
export const previewImport = (propertyId: string, data: Record<string, unknown>) => apiPost(`${root(propertyId)}/preview`, data);
export const confirmImport = (propertyId: string, data: Record<string, unknown>) => apiPost(`${root(propertyId)}/confirm`, data);
export const getImportResult = (propertyId: string, importId: string) => apiRequestGet(`/properties/${encodeURIComponent(propertyId)}/bulk-imports/${encodeURIComponent(importId)}`);
